export default __webpack_public_path__ + "static/media/ReceivedFileIcon.05ff533c.svg";